import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { UploadImageField } from 'components/inputs/UploadImageField/UploadImageField'
import { ContentSection } from 'components/data/ContentSection/ContentSection'
import { LanguagesSelect } from 'components/data/LanguagesSelect/LanguagesSelect'
import { TextField } from 'components/inputs/TextField/TextField'
import { LabelSelect } from 'components/data/LabelSelect/LabelSelect'

const selectStyles = css`
  min-width: 200px;
`

const StyledTextField = styled(TextField)`
  width: 100%;
`

const StyledUploadImageField = styled(UploadImageField)`
  width: 200px;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 800px;
`

const InfoSection = styled(ContentSection)`
  flex: 1;
  margin-top: ${({ theme }) => theme.spacing(2.5)}px;
  min-width: 200px;
`

const TranslationLanguagesSelect = styled(LanguagesSelect)`
  ${selectStyles}
`

const StyledLabelSelect = styled(LabelSelect)`
  ${selectStyles}
`

export {
  StyledTextField as TextField,
  StyledUploadImageField as UploadImageField,
  Form,
  InfoSection,
  TranslationLanguagesSelect,
  StyledLabelSelect as LabelSelect,
}
